export default "__VITE_ASSET__BBmWyctU__"